import sendRequest from "hooks/useAxios";
import { sendRequestAPI2 } from "hooks/useAxios";
import { useEffect, useState, useContext } from "react";
import Select from "react-select";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { GoDiffAdded } from "react-icons/go";
import toast from "react-hot-toast";
import toastFunction from "utils/toast";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { GrTableAdd } from "react-icons/gr";
import ReactTooltip from "react-tooltip";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import logo from "assets/images/sitelogo.svg";

export default function TermsOfSaleModal({
  adminId,
  type,
  setShopInfoUpdater
}) {
  const auth = useContext(WithAuthentication);
  const [show, setShow] = useState(false);
  const [productList, setProductList] = useState([]);
  const [saleTerms, setSaleTerms] = useState({
    productId: "",
    singleSaleTerms: {
      deliveryPrice: 0,
      discountDate: 0,
      // discountDateTo: 0,
      // minCount: 0,
      maxCount: 1,
      step: 1,
      price: 0,
      discount: 0,
      itemcount: 0,
      status: false
    },
    groupSaleTerms: {
      finishingDate: "",
      deliveryPrice: "",
      status: false,
      rangeList: [
        {
          min: 1,
          max: 2,
          price: "",
          //  minCount: "",
          maxCount: 1,
          step: 1
        }
      ]
    }
  });
  const [rangeCount, setRangeCount] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [textError, setTextError] = useState({
    single: "",
    group: "",
    priceGroup: "",
    submitError: ""
  });
  const [singleTxt, setSingleTxt] = useState({ single: "", group: "" });
  const [singleFlag, setSingleFlag] = useState(false);
  const [groupFlag, setGroupFlag] = useState(false);
  let bId = useParams();

  const [is_single, setIs_single] = useState(0);
  const [have_group_sale, setHave_group_sale] = useState(0);
  const [priceRange, setPriceRange] = useState({ max: "", min: "" });
  const [tooltipSingle, setTooltipSingle] = useState("");
  const [tooltipGroup, setTooltipGroup] = useState("");
  const flagHandler = type => {
    if (type == "group") {
      setGroupFlag(true);
    } else if (type == "single") {
      setSingleFlag(true);
    }
  };
  useEffect(() => {
    saleTerms.singleSaleTerms.status
      ? setTooltipSingle("غیر فعال")
      : setTooltipSingle("فعال");
  }, [saleTerms.singleSaleTerms.status]);
  useEffect(() => {
    saleTerms.groupSaleTerms.status
      ? setTooltipGroup("غیر فعال")
      : setTooltipGroup(" فعال");
  }, [saleTerms.groupSaleTerms.status]);
  useEffect(() => {
    if (type != undefined) {
      sendRequestAPI2(
        "getlistofproduct",
        type == 0
          ? { main_shop_id: bId.businessId }
          : { shop_id: bId.businessId }
      ).then(({ data }) => {
        setProductList(
          data?.productList?.map(value => {
            return {
              label: value.title,
              value: value.id,
              price: value.default_price,
              interest_rates: value.Interest_rates,
              mainshop_commission: value.mainshop_commission,
              price_from: value.price_from,
              price_to: value.price_to
            };
          })
        );
      });
    }
  }, [type]);

  useEffect(() => ReactTooltip.rebuild());

  const isLastRange = index => {
    return saleTerms.groupSaleTerms.rangeList.length == index + 1;
  };
  const checkInventory = async function() {
    let temp = "";
    if (saleTerms.groupSaleTerms.status && saleTerms.singleSaleTerms.status) {
      temp = "both";
    } else if (saleTerms.singleSaleTerms.status) {
      temp = "single";
    } else if (saleTerms.groupSaleTerms.status) {
      temp = "group";
    }
    let x = new Promise(function(resolve) {
      sendRequest("check_products_inventory", {
        business_id: bId.businessId,
        product_id: saleTerms.productId,
        new_inventory:
          +(saleTerms.singleSaleTerms.status
            ? saleTerms.singleSaleTerms.itemcount
            : 0) +
          +(saleTerms.groupSaleTerms.status
            ? saleTerms.groupSaleTerms.rangeList[
                saleTerms.groupSaleTerms.rangeList.length - 1
              ].max
            : 0),
        // is_single: saleTerms.singleSaleTerms.status ? 1 : 0,
        type: temp
      }).then(data => {
        let y = data.data.status == "1" ? true : false;
        resolve(y);
      });
    });

    return x;
  };
  const sendGroupTerms = () => {
    // if (saleTerms.groupSaleTerms.status == true) {
    // let temp;
    // if (
    //   saleTerms.groupSaleTerms.deliveryPrice != "" ||
    //   saleTerms.groupSaleTerms.finishingDate != "" ||
    //   saleTerms.groupSaleTerms.rangeList != ""
    // ) {
    //   temp = 1;
    //   setHave_group_sale(1);
    //   console.log("have_group_sale", have_group_sale);
    // }

    return sendRequest("addproductpriceing", {
      product_id: saleTerms.productId,
      submit_price_group: saleTerms.groupSaleTerms.deliveryPrice,
      group_sale_endtime: saleTerms.groupSaleTerms.finishingDate,
      businesses_id: bId.businessId,
      is_main_shop: type == "0" ? 1 : 0,
      // group_sales: saleTerms.groupSaleTerms.status ? 1 : 0,
      // have_group_sale: temp,
      have_group_sale: saleTerms.groupSaleTerms.status ? "1" : "0",
      productPricing: JSON.stringify(
        saleTerms.groupSaleTerms.rangeList.map((value, index) => {
          return [
            // +value.minCount,
            +value.maxCount,
            +value.price,
            +saleTerms.groupSaleTerms.rangeList[index + 1]?.price,
            +value.min,
            +value.max,
            +value.step
          ];
        })
      )
    }).then(data => {
      if (data.status == 1) {
        window.location.reload();
      }
      if (data.data.status == 1) {
        toastFunction("success", "شرایط گروهی محصول با موفقیت اضافه شد.");

        // document.querySelector("#addTermsOfSale .btn-close").click();
        setShow(false);
        setRangeCount(0);
        setShopInfoUpdater(prev => !prev);

        setSaleTerms({
          productId: "",
          singleSaleTerms: {
            deliveryPrice: "",
            discountDate: "",
            maxCount: "",
            step: "",
            price: "",
            discount: "",
            itemcount: ""
          },
          groupSaleTerms: {
            finishingDate: "",
            deliveryPrice: "",
            status: false,
            rangeList: [
              {
                min: 0,
                max: 1,
                price: "",
                //  minCount: "",
                maxCount: 1,
                step: 1
              }
            ]
          }
        });
      } else if (data.data.status == -2) {
        toastFunction("error", "شرایط فروش برای این محصول تعریف شده است.");
      } else {
        toastFunction("error", "افزودن شرایط گروهی با مشکل مواجه شده است.");
      }
    });
    // }
  };
  const sendSingleTerms = () => {
    let temp1;
    // if (
    //   saleTerms.singleSaleTerms.deliveryPrice != "" ||
    //   saleTerms.singleSaleTerms.step != "" ||
    //   saleTerms.singleSaleTerms.maxCount != "" ||
    //   saleTerms.singleSaleTerms.price != "" ||
    //   saleTerms.singleSaleTerms.discount != "" ||
    //   saleTerms.singleSaleTerms.itemcount != "" ||
    //   saleTerms.singleSaleTerms.discountDate != ""
    // ) {
    //   temp1 = 1;
    //   setIs_single(1);
    // }
    // if (type == 1) {
    return sendRequest("addproductbusinesslink", {
      product_id: saleTerms.productId,
      businesses_id: bId.businessId,
      // min_num: saleTerms.singleSaleTerms.minCount,
      max_num: saleTerms.singleSaleTerms.maxCount,
      step: saleTerms.singleSaleTerms.step,
      submit_price: saleTerms.singleSaleTerms.deliveryPrice,
      // main_discount_starttime: saleTerms.singleSaleTerms.discountDate,
      price: saleTerms.singleSaleTerms.price,
      main_discount: saleTerms.singleSaleTerms.discount,
      itemcount: saleTerms.singleSaleTerms.itemcount,
      main_discount_endtime: saleTerms.singleSaleTerms.discountDate,
      is_single: saleTerms.singleSaleTerms.status ? 1 : 0
      // is_single: temp1
    }).then(data => {
      if (data.data.status == 1) {
        toastFunction("success", "شرایط تکی با موفقیت اضافه شد.");

        sendGroupTerms();
      } else if (data.data.status == -2) {
        toastFunction("error", "شرایط فروش فعال برای این محصول وجود دارد.");
      }
      if (data.status == 1) {
        window.location.reload();
      }
    });
    // }
  };
  const validation = (type, maxCount, minCount, step, maxPerBuy, price) => {
    // console.log("**", type, maxCount, minCount, step, maxPerBuy, price);
    let x = "";
    let valid = true;
    if (type == "single") {
      x = "singleSaleTerms";
    } else if (type == "group") {
      x = "groupSaleTerms";
    }
    if (
      saleTerms[x]["status"] &&
      ((maxCount - minCount + 1) % step != 0 ||
        maxPerBuy == 0 ||
        maxPerBuy == "" ||
        (maxPerBuy != 0 && (maxCount - minCount + 1) % maxPerBuy != 0) ||
        maxPerBuy > maxCount - minCount + 1 ||
        step > maxCount - minCount + 1 ||
        (maxPerBuy != 0 && maxPerBuy % step != 0) ||
        step == 0 ||
        price > +priceRange.max ||
        price < +priceRange.min)
    ) {
      type == "group" &&
        setTextError({
          ...textError,
          [type]: (
            <ol>
              <li>قدم باید بر موجودی بخشپذیر باشد(حداقل قدم=1).</li>
              <li>قدم باید بر بیشترین میزان بخشپذیر باشد.</li>
              <li>قدم و بیشترین میزان باید کوچکتر مساوی موجودی باشد.</li>
              <li>
                قیمت باید بین {addCommas(priceRange.min)} و{" "}
                {addCommas(priceRange.max)} باشد.
              </li>
            </ol>
          )
        });
      type == "single" &&
        setSingleTxt({
          ...singleTxt,
          [type]: (
            <ol>
              <li>قدم باید بر موجودی بخشپذیر باشد.</li>
              <li>قدم باید بر بیشترین میزان بخشپذیر باشد.</li>
              <li>قدم و بیشترین میزان باید کوچکتر مساوی موجودی باشد.</li>
              <li>
                قیمت باید بین {addCommas(priceRange.min)} و{" "}
                {addCommas(priceRange.max)} باشد.
              </li>
            </ol>
          )
        });
      valid = false;
    } else {
      type == "group" &&
        setTextError({
          ...textError,
          [type]: ""
        });
      type == "single" &&
        setSingleTxt({
          ...singleTxt,
          [type]: ""
        });
    }
    return valid;
  };
  const submitValidation = () => {
    let v = true;
    if (
      !validation(
        "single",
        saleTerms.singleSaleTerms.itemcount,
        1,
        saleTerms.singleSaleTerms.step,
        saleTerms.singleSaleTerms.maxCount
      )
    ) {
      v = false;
    }
    for (let i = 0; i < saleTerms.groupSaleTerms.rangeList.length; i++) {
      if (
        !validation(
          "group",
          saleTerms.groupSaleTerms.rangeList[i].max,
          saleTerms.groupSaleTerms.rangeList[i].min,
          saleTerms.groupSaleTerms.rangeList[i].step,
          saleTerms.groupSaleTerms.rangeList[i].maxCount,
          saleTerms.groupSaleTerms.rangeList[i].price
        )
      ) {
        v = false;
      }
    }
    return v;
  };
  const priceCheck = price => {
    let v = false;
    if (price < +priceRange.max && price > +priceRange.min) {
      v = true;
    }
    return v;
  };
  console.log("saleterms", saleTerms);
  console.log("**", selectedProduct, priceRange);
  // console.log("textError", textError);
  // console.log("rangecount", rangeCount);
  // console.log("single group", singleFlag, groupFlag);
  return (
    <>
      {auth.isLogged && auth.userInfo.id == adminId && (
        // <div
        //   className="position-fixed"
        //   style={{
        //     zIndex: "10"
        //     // right: "-50px",
        //     // top: "150px"
        //   }}
        //   onClick={() => {
        //     setShow(true);
        //   }}
        // >
        //   <button
        //     type="button"
        //     className="btn text-white mx-2 add-condition"
        //     data-bs-toggle="modal"
        //     data-bs-target="#addTermsOfSale"
        //     style={{ backgroundColor: "#106666" }}
        //     data-for="gm-tooltip"
        //     data-tip="افزودن شرایط فروش"
        //   >
        //     <GrTableAdd
        //       className="icon-style"
        //       style={{
        //         fontSize: "40px",
        //         padding: "2px"
        //       }}
        //     />
        //   </button>
        //   {/* <ReactTooltip /> */}
        // </div>
        <button
          className="  col-lg-2 mx-1 col-sm-3 col-5 py-2 rounded my-1 adminBtn shadow"
          data-bs-toggle="modal"
          data-bs-target="#addTermsOfSale"
          onClick={() => {
            setShow(true);
            setSaleTerms({
              productId: "",
              singleSaleTerms: {
                deliveryPrice: 0,
                discountDate: 0,
                // discountDateTo: 0,
                // minCount: 0,
                maxCount: 1,
                step: 1,
                price: 0,
                discount: 0,
                itemcount: 0,
                status: false
              },
              groupSaleTerms: {
                finishingDate: "",
                deliveryPrice: "",
                status: false,
                rangeList: [
                  {
                    min: 1,
                    max: 2,
                    price: "",
                    //  minCount: "",
                    maxCount: 1,
                    step: 1
                  }
                ]
              }
            });
          }}
        >
          افزودن شرایط فروش
        </button>
      )}
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <div>
          <div
            // className="modal fade"
            id="addTermsOfSale"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="modelTitleId"
            aria-hidden="true"
          >
            <div
              //  className="modal-dialog"
              role="document"
            >
              <div
              // className="modal-content"
              >
                <Modal.Header closeButton>
                  <div className="">
                    <h5 className="">افزودن شرایط فروش</h5>
                    {/* <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    /> */}
                  </div>
                </Modal.Header>
                <Modal.Body>
                  <div className="">
                    <div>
                      <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link active"
                            id="addSale-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#addSale"
                            type="button"
                            role="tab"
                            aria-controls="addSale"
                            aria-selected="true"
                          >
                            افزودن شرایط
                          </button>
                        </li>
                        {type == 1 && (
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link"
                              id="recordSale-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#recordSale"
                              type="button"
                              role="tab"
                              aria-controls="recordSale"
                              aria-selected="false"
                            >
                              سابقه خرید
                            </button>
                          </li>
                        )}
                      </ul>
                      <div className="tab-content" id="myTabContent1">
                        <div
                          className="tab-pane fade show active"
                          id="addSale"
                          role="tabpanel"
                          aria-labelledby="addSale-tab"
                        >
                          <form>
                            <div>
                              <div class="mt-4 mb-5">
                                <label
                                  htmlFor="#choose-product"
                                  className="-label mb-1"
                                >
                                  انتخاب محصول :
                                </label>

                                <Select
                                  class="form-control"
                                  name=""
                                  id="choose-product"
                                  options={productList}
                                  onChange={e => {
                                    setSaleTerms(prev => {
                                      return { ...prev, productId: e.value };
                                    });
                                    setSelectedProduct(e);
                                    setTextError({
                                      single: "",
                                      group: "",
                                      priceGroup: ""
                                    });
                                    if (type == "0") {
                                      setPriceRange({
                                        min: e.price_from,
                                        max: e.price_to
                                      });
                                    } else if (type == "1") {
                                      setPriceRange({
                                        min: 0,
                                        max:
                                          +e.price_to +
                                          (+e.price_to * +e.interest_rates) /
                                            100
                                      });
                                    }
                                  }}
                                >
                                  {productList?.map(value => {
                                    <option value={value.id}>
                                      {value.title}
                                    </option>;
                                  })}
                                </Select>
                              </div>
                              <div
                                className="text-center text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {saleTerms.productId &&
                                  `قیمت این محصول میتواند بین ${addCommas(
                                    priceRange.min
                                  )} تا ${addCommas(
                                    priceRange.max
                                  )} تومان باشد.`}
                              </div>

                              {/* <div className="mb-3">
                  <label htmlFor="#freight-cost" className="form-label">
                    هزینه باربری
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name
                    id="freight-cost"
                    placeholder
                    
                  />
                </div> */}
                              {/* <h4 className="mt-4">شرایط فروش تکی</h4> */}

                              {type == 1 && (
                                <div className="form-check form-switch d-flex justify-content-between px-2 mt-4">
                                  <label
                                    className="form-check-label"
                                    htmlFor="singleSale"
                                  >
                                    <h4 classname="mt-4">شرایط فروش تکی</h4>
                                  </label>

                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="singleSale"
                                    onChange={e => {
                                      setSaleTerms(prev => {
                                        return {
                                          ...prev,
                                          singleSaleTerms: {
                                            ...prev.singleSaleTerms,
                                            status: e.target.checked
                                          }
                                        };
                                      });
                                    }}
                                    data-for="gm-tooltip"
                                    data-tip={tooltipSingle}
                                  />
                                  <ReactTooltip />
                                </div>
                              )}
                              <p
                                className="text-center text-danger"
                                style={{ fontSize: 12 }}
                              >
                                {singleTxt.single}
                              </p>
                              {saleTerms.singleSaleTerms.status && (
                                <div>
                                  <div className="mb-3">
                                    <label
                                      htmlFor="delivery-price-1"
                                      className="form-label"
                                    >
                                      هزینه ارسال
                                      <span style={{ fontSize: 12 }}>
                                        (تومان)
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name
                                      id="delivery-price-1"
                                      placeholder
                                      value={addCommas(
                                        saleTerms.singleSaleTerms.deliveryPrice
                                      )}
                                      onChange={e => {
                                        flagHandler("single");
                                        let value = removeCommas(
                                          e.target.value
                                        );
                                        try {
                                          if (isNaN(value))
                                            throw new Error(
                                              "لطفا عدد را به درستی وارد نمایید."
                                            );
                                          setSaleTerms(prev => {
                                            return {
                                              ...prev,
                                              singleSaleTerms: {
                                                ...prev.singleSaleTerms,
                                                deliveryPrice: +value
                                              }
                                            };
                                          });
                                        } catch (ex) {
                                          toast.error(ex.message);
                                        }
                                      }}
                                    />
                                    {/* <small>تومان</small> */}
                                  </div>
                                  <div className="mb-3">
                                    <label
                                      htmlFor="main-price"
                                      className="form-label"
                                    >
                                      قیمت
                                      <span style={{ fontSize: 12 }}>
                                        (تومان)
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name
                                      id="main-price"
                                      placeholder
                                      value={addCommas(
                                        saleTerms.singleSaleTerms.price
                                      )}
                                      onChange={e => {
                                        flagHandler("single");
                                        let value = removeCommas(
                                          e.target.value
                                        );
                                        try {
                                          if (isNaN(value))
                                            throw new Error(
                                              "لطفا عدد را به درستی وارد نمایید."
                                            );
                                          if (
                                            value <
                                            saleTerms.singleSaleTerms.discount
                                          )
                                            throw new Error(
                                              "قیمت نمی تواند از تخفیف کمتر باشد!"
                                            );

                                          // if (
                                          //   value >
                                          //   +selectedProduct.price +
                                          //     (+selectedProduct.price *
                                          //       +selectedProduct.interest_rates) /
                                          //       100
                                          // )
                                          //   throw new Error(
                                          //     `قیمت نمی تواند از قیمت اصلی و سود آن(${addCommas(
                                          //       +selectedProduct.price +
                                          //         (+selectedProduct.price *
                                          //           +selectedProduct.interest_rates) /
                                          //           100
                                          //     )})تومان بیشتر باشد`
                                          //   );
                                          setSaleTerms(prev => {
                                            return {
                                              ...prev,
                                              singleSaleTerms: {
                                                ...prev.singleSaleTerms,
                                                price: +value
                                              }
                                            };
                                          });
                                        } catch (ex) {
                                          toast.error(ex.message);
                                        }
                                      }}
                                    />
                                    {/* <small>تومان</small> */}
                                  </div>
                                  <div className="mb-3">
                                    <label
                                      htmlFor="discount"
                                      className="form-label"
                                    >
                                      تخفیف
                                      <span style={{ fontSize: 12 }}>
                                        (تومان)
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name
                                      id="discount"
                                      placeholder
                                      value={addCommas(
                                        saleTerms.singleSaleTerms.discount
                                      )}
                                      onChange={e => {
                                        flagHandler("single");
                                        let value = removeCommas(
                                          e.target.value
                                        );
                                        try {
                                          if (isNaN(value))
                                            throw new Error(
                                              "لطفا عدد را به درستی وارد نمایید."
                                            );
                                          if (
                                            value >=
                                            saleTerms.singleSaleTerms.price
                                          )
                                            throw new Error(
                                              "تخفیف نمی تواند از قیمت بیشتر باشد!"
                                            );
                                          setSaleTerms(prev => {
                                            return {
                                              ...prev,
                                              singleSaleTerms: {
                                                ...prev.singleSaleTerms,
                                                discount: +value
                                              }
                                            };
                                          });
                                        } catch (ex) {
                                          toast.error(ex.message);
                                        }
                                      }}
                                    />
                                    {/* <small>تومان</small> */}
                                  </div>
                                  <div className="mb-3">
                                    <label
                                      htmlFor="itemcount"
                                      className="form-label"
                                    >
                                      موجودی{" "}
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      name
                                      id="itemcount"
                                      placeholder
                                      step={saleTerms.singleSaleTerms.itemcount}
                                      value={
                                        saleTerms.singleSaleTerms.itemcount
                                      }
                                      onChange={e => {
                                        flagHandler("single");
                                        let value = e.target.value;
                                        try {
                                          if (isNaN(value))
                                            throw new Error(
                                              "لطفا عدد را به درستی وارد نمایید."
                                            );

                                          setSaleTerms(prev => {
                                            return {
                                              ...prev,
                                              singleSaleTerms: {
                                                ...prev.singleSaleTerms,
                                                itemcount: +value
                                              }
                                            };
                                          });
                                        } catch (ex) {
                                          toast.error(ex.message);
                                        }
                                      }}
                                    />
                                  </div>
                                  <div class="mb-3">
                                    <label for="price-time" class="form-label">
                                      زمان تخفیف
                                    </label>
                                    <DatePicker
                                      id="price-time"
                                      onChange={e => {
                                        flagHandler("single");
                                        setSaleTerms(prev => {
                                          return {
                                            ...prev,
                                            singleSaleTerms: {
                                              ...prev.singleSaleTerms,
                                              discountDate: e.unix
                                              // discountDateTo: e[1]?.unix
                                            }
                                          };
                                        });
                                      }}
                                      // range
                                      calendar={persian}
                                      locale={persian_fa}
                                      calendarPosition="bottom-right"
                                    />
                                  </div>

                                  <div className="mb-3 d-flex">
                                    {/* <div className="mb-3 mx-3">
                            <label htmlFor="min-count" className="form-label">
                              کمترین میزان
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name
                              id="min-count"
                              aria-describedby="helpId"
                              placeholder
                              onChange={e => {
                                setSaleTerms(prev => {
                                  return {
                                    ...prev,
                                    singleSaleTerms: {
                                      ...prev.singleSaleTerms,
                                      minCount: e.target.value
                                    }
                                  };
                                });
                              }}
                            />
                          </div> */}

                                    <div className="mb-3 mx-3 w-50">
                                      <label
                                        htmlFor="max-count"
                                        className="form-label"
                                      >
                                        بیشترین میزان
                                      </label>
                                      <input
                                        type="number"
                                        id="max-count"
                                        className="form-control"
                                        value={
                                          saleTerms.singleSaleTerms.maxCount
                                        }
                                        // value="1"
                                        // min="5"
                                        step={saleTerms.singleSaleTerms.step}
                                        min={saleTerms.singleSaleTerms.step}
                                        max={
                                          saleTerms.singleSaleTerms.itemcount
                                        }
                                        onChange={e => {
                                          flagHandler("single");
                                          setSaleTerms(prev => {
                                            return {
                                              ...prev,
                                              singleSaleTerms: {
                                                ...prev.singleSaleTerms,
                                                maxCount: e.target.value
                                              }
                                            };
                                          });
                                        }}
                                        // onBlur={(e) => {
                                        //   let num = e.target.value;
                                        //   if (
                                        //     num < e.target.min ||
                                        //     num > e.target.max ||
                                        //     (num - e.target.min) %
                                        //       saleTerms.singleSaleTerms.step !=
                                        //       0
                                        //   ) {
                                        //     setSaleTerms((prev) => {
                                        //       return {
                                        //         ...prev,
                                        //         singleSaleTerms: {
                                        //           ...prev.singleSaleTerms,
                                        //           maxCount: prev.singleSaleTerms.minCount,
                                        //         },
                                        //       };
                                        //     });
                                        //   }
                                        // }}
                                        placeholder
                                      />
                                    </div>
                                    <div className="mb-3 mx-3 w-50">
                                      <label
                                        htmlFor="step"
                                        className="form-label"
                                      >
                                        قدم
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        value={saleTerms.singleSaleTerms.step}
                                        name
                                        id="step"
                                        onChange={e => {
                                          flagHandler("single");
                                          setSaleTerms(prev => {
                                            return {
                                              ...prev,
                                              singleSaleTerms: {
                                                ...prev.singleSaleTerms,
                                                step: e.target.value
                                              }
                                            };
                                          });
                                        }}
                                        placeholder
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="form-check form-switch d-flex justify-content-between px-2 mt-3">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  <h4 classname="mt-4">شرایط فروش گروهی</h4>
                                </label>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="flexSwitchCheckDefault"
                                  onChange={e => {
                                    setSaleTerms(prev => {
                                      return {
                                        ...prev,
                                        groupSaleTerms: {
                                          ...prev.groupSaleTerms,
                                          status: e.target.checked
                                        }
                                      };
                                    });
                                  }}
                                  data-for="gm-tooltip"
                                  data-tip={tooltipGroup}
                                />
                              </div>
                              {saleTerms.groupSaleTerms.status && (
                                <>
                                  <div className="mb-3">
                                    <label
                                      htmlFor="delivery-price-2"
                                      className="form-label"
                                    >
                                      هزینه ارسال
                                      <span style={{ fontSize: 12 }}>
                                        (تومان)
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name
                                      id="delivery-price-2"
                                      value={addCommas(
                                        saleTerms.groupSaleTerms.deliveryPrice
                                      )}
                                      onChange={e => {
                                        flagHandler("group");
                                        let value = removeCommas(
                                          e.target.value
                                        );
                                        setSaleTerms(prev => {
                                          return {
                                            ...prev,
                                            groupSaleTerms: {
                                              ...prev.groupSaleTerms,
                                              deliveryPrice: +value
                                            }
                                          };
                                        });
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <label htmlFor="finishing-time">
                                      اتمام فروش گروهی
                                    </label>
                                    <DatePicker
                                      id="finishing-time"
                                      onChange={e => {
                                        flagHandler("group");
                                        setSaleTerms(prev => {
                                          return {
                                            ...prev,
                                            groupSaleTerms: {
                                              ...prev.groupSaleTerms,
                                              finishingDate: e.unix
                                            }
                                          };
                                        });
                                      }}
                                      // range
                                      calendar={persian}
                                      locale={persian_fa}
                                      calendarPosition="bottom-right"
                                    />
                                  </div>
                                  <div className="my-3">
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        border: "1px solid #f2ede1",
                                        borderRadius: "5px",
                                        padding: "0px 10px"
                                      }}
                                      onClick={e => {
                                        if (saleTerms["productId"] == "") {
                                          toast.error(
                                            "لطفا محصول را انتخاب کنید!"
                                          );
                                        } else if (
                                          saleTerms["productId"] != "" &&
                                          validation(
                                            "group",
                                            saleTerms.groupSaleTerms.rangeList[
                                              saleTerms.groupSaleTerms.rangeList
                                                .length - 1
                                            ].max,
                                            saleTerms.groupSaleTerms.rangeList[
                                              saleTerms.groupSaleTerms.rangeList
                                                .length - 1
                                            ].min,
                                            saleTerms.groupSaleTerms.rangeList[
                                              saleTerms.groupSaleTerms.rangeList
                                                .length - 1
                                            ].step,
                                            saleTerms.groupSaleTerms.rangeList[
                                              saleTerms.groupSaleTerms.rangeList
                                                .length - 1
                                            ].maxCount,
                                            saleTerms.groupSaleTerms.rangeList[
                                              saleTerms.groupSaleTerms.rangeList
                                                .length - 1
                                            ].price
                                          )
                                        ) {
                                          if (rangeCount < 2) {
                                            setRangeCount(rangeCount + 1);
                                            if (
                                              saleTerms.groupSaleTerms.rangeList.at(
                                                -1
                                              ).min <
                                              saleTerms.groupSaleTerms.rangeList.at(
                                                -1
                                              ).max
                                            ) {
                                              setSaleTerms(prev => {
                                                return {
                                                  ...prev,
                                                  groupSaleTerms: {
                                                    ...prev.groupSaleTerms,
                                                    rangeList: [
                                                      ...prev.groupSaleTerms
                                                        .rangeList,
                                                      {
                                                        min:
                                                          +prev.groupSaleTerms.rangeList.at(
                                                            -1
                                                          ).max + 1,
                                                        max:
                                                          +prev.groupSaleTerms.rangeList.at(
                                                            -1
                                                          ).max + 2,
                                                        price: "",
                                                        maxCount: "",
                                                        step: ""
                                                      }
                                                    ]
                                                  }
                                                };
                                              });
                                            }
                                          } else {
                                            toast.error(
                                              " شما قادر هستید فقط 3 رنج انتخاب کنید! "
                                            );
                                          }
                                        }
                                      }}
                                    >
                                      <GoDiffAdded
                                        style={{
                                          color: "green",
                                          borderRadius: "30%",
                                          marginLeft: "10px"
                                        }}
                                      ></GoDiffAdded>
                                      افزودن رنج
                                    </span>
                                  </div>
                                  <p
                                    className="text-center text-danger"
                                    style={{ fontSize: 12 }}
                                  >
                                    {textError.group}
                                  </p>
                                  <p
                                    className="text-center text-danger"
                                    style={{ fontSize: 12 }}
                                  >
                                    {textError.priceGroup}
                                  </p>
                                  <p
                                    className="text-center text-danger"
                                    style={{ fontSize: 12 }}
                                  >
                                    {textError.submitError}
                                  </p>
                                  {saleTerms.groupSaleTerms.rangeList.map(
                                    (value, index) => {
                                      return (
                                        <div
                                          className={`mb-3 ${!isLastRange(
                                            index
                                          ) && "disabled-item"}`}
                                        >
                                          <div
                                            className={`d-flex flex-wrap justify-content-between align-items-center mt-4 
                      "active-progress_active"
                         
                    `}
                                          >
                                            <span className="text-center">
                                              <input
                                                type="number"
                                                className="form-control"
                                                style={{ width: "70px" }}
                                                step={value.step}
                                                value={value.max}
                                                onChange={e => {
                                                  flagHandler("group");
                                                  if (isLastRange(index)) {
                                                    let temp = [
                                                      ...saleTerms
                                                        .groupSaleTerms
                                                        .rangeList
                                                    ];
                                                    temp[index].max =
                                                      e.target.value;
                                                    setSaleTerms(prev => {
                                                      return {
                                                        ...prev,
                                                        groupSaleTerms: {
                                                          ...prev.groupSaleTerms,
                                                          rangeList: [...temp]
                                                        }
                                                      };
                                                    });
                                                  }
                                                }}
                                              />
                                              <small>بیشینه تعداد</small>
                                            </span>
                                            <span className="text-center ">
                                              <input
                                                type="text"
                                                className="form-control"
                                                style={{ width: "120px" }}
                                                value={addCommas(value.price)}
                                                onChange={e => {
                                                  flagHandler("group");
                                                  let value = removeCommas(
                                                    e.target.value
                                                  );
                                                  try {
                                                    if (isNaN(value))
                                                      throw new Error(
                                                        "لطفا عدد را به درستی وارد نمایید."
                                                      );

                                                    if (isLastRange(index)) {
                                                      // if (

                                                      //   value >
                                                      //   +selectedProduct.price +
                                                      //     (+selectedProduct.price *
                                                      //       +selectedProduct.interest_rates) /
                                                      //       100
                                                      // )
                                                      //   throw new Error(
                                                      //     `قیمت نمی تواند از قیمت اصلی و سود آن(${addCommas(
                                                      //       +selectedProduct.price +
                                                      //         (+selectedProduct.price *
                                                      //           +selectedProduct.interest_rates) /
                                                      //           100
                                                      //     )})تومان بیشتر باشد`
                                                      //   );
                                                      let temp = [
                                                        ...saleTerms
                                                          .groupSaleTerms
                                                          .rangeList
                                                      ];
                                                      temp[
                                                        index
                                                      ].price = +value;
                                                      setSaleTerms(prev => {
                                                        return {
                                                          ...prev,
                                                          groupSaleTerms: {
                                                            ...prev.groupSaleTerms,
                                                            rangeList: [...temp]
                                                          }
                                                        };
                                                      });
                                                    }
                                                  } catch (ex) {
                                                    toast.error(ex.message);
                                                  }
                                                }}
                                              />
                                              <small>
                                                قیمت
                                                <span style={{ fontSize: 12 }}>
                                                  (تومان)
                                                </span>
                                              </small>
                                            </span>
                                            <span className="text-center ">
                                              <input
                                                type="number"
                                                className="form-control"
                                                style={{ width: "70px" }}
                                                value={value.min}
                                                onChange={e => {
                                                  flagHandler("group");
                                                  if (
                                                    index != 0 &&
                                                    saleTerms.groupSaleTerms
                                                      .rangeList.length == 1
                                                  ) {
                                                    let temp = [
                                                      ...saleTerms
                                                        .groupSaleTerms
                                                        .rangeList
                                                    ];
                                                    temp[index].min =
                                                      e.target.value;
                                                    setSaleTerms(prev => {
                                                      return {
                                                        ...prev,
                                                        groupSaleTerms: {
                                                          ...prev.groupSaleTerms,
                                                          rangeList: [...temp]
                                                        }
                                                      };
                                                    });
                                                  }
                                                }}
                                              />
                                              <small>کمینه تعداد</small>
                                            </span>
                                          </div>
                                          <div
                                            dir="ltr"
                                            className="progress my-1 bg-light"
                                          >
                                            {isLastRange(index) && (
                                              <span
                                                style={{ fontSize: "14px" }}
                                                onClick={() => {
                                                  flagHandler("group");
                                                  setRangeCount(rangeCount - 1);
                                                  let temp = [
                                                    ...saleTerms.groupSaleTerms
                                                      .rangeList
                                                  ];
                                                  temp.pop();
                                                  setSaleTerms(prev => {
                                                    return {
                                                      ...prev,
                                                      groupSaleTerms: {
                                                        ...prev.groupSaleTerms,
                                                        rangeList: [...temp]
                                                      }
                                                    };
                                                  });
                                                }}
                                              >
                                                <IoIosRemoveCircleOutline
                                                  style={{
                                                    marginButton: "10px"
                                                  }}
                                                ></IoIosRemoveCircleOutline>
                                              </span>
                                            )}

                                            <div
                                              dir="ltr"
                                              id="progress-bar"
                                              className="progress-bar"
                                              role="progressbar"
                                              style={{
                                                width: `${100}% `
                                              }}
                                              aria-valuemin="0"
                                              aria-valuemax="100"
                                            ></div>
                                          </div>
                                          {isLastRange(index) &&
                                            saleTerms.groupSaleTerms.rangeList[
                                              index
                                            ].min >=
                                              saleTerms.groupSaleTerms
                                                .rangeList[index].max && (
                                              <small style={{ color: "red" }}>
                                                بیشینه باید بیشتر از کمینه باشد.
                                              </small>
                                            )}
                                          <div className="mb-3 d-flex">
                                            {/* <div className="mb-3 mx-3">
                                        <label
                                          htmlFor={`min-count-${index}`}
                                          className="form-label"
                                        >
                                          کمترین میزان
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          name
                                          id={`min-count-${index}`}
                                          aria-describedby="helpId"
                                          placeholder
                                          value={
                                            saleTerms.groupSaleTerms.rangeList[
                                              index
                                            ].minCount
                                          }
                                          onChange={(e) => {
                                            if (isLastRange(index)) {
                                              let temp = [
                                                ...saleTerms.groupSaleTerms
                                                  .rangeList,
                                              ];
                                              temp[index].minCount =
                                                e.target.value;
                                              setSaleTerms((prev) => {
                                                return {
                                                  ...prev,
                                                  groupSaleTerms: {
                                                    ...prev.groupSaleTerms,
                                                    rangeList: [...temp],
                                                  },
                                                };
                                              });
                                            }
                                          }}
                                        />
                                      </div> */}

                                            <div className="mb-3 mx-3 ">
                                              <label
                                                htmlFor={`max-count-${index}`}
                                                className="form-label"
                                              >
                                                بیشترین میزان
                                              </label>
                                              <input
                                                type="number"
                                                id={`max-count-${index}`}
                                                className="form-control"
                                                min={value.step}
                                                value={
                                                  saleTerms.groupSaleTerms
                                                    .rangeList[index].maxCount
                                                }
                                                onChange={e => {
                                                  flagHandler("group");
                                                  if (isLastRange(index)) {
                                                    let temp = [
                                                      ...saleTerms
                                                        .groupSaleTerms
                                                        .rangeList
                                                    ];
                                                    temp[index].maxCount =
                                                      e.target.value;
                                                    setSaleTerms(prev => {
                                                      return {
                                                        ...prev,
                                                        groupSaleTerms: {
                                                          ...prev.groupSaleTerms,
                                                          rangeList: [...temp]
                                                        }
                                                      };
                                                    });
                                                  }
                                                }}
                                              />
                                            </div>
                                            <div className="mb-3 mx-3 ">
                                              <label
                                                htmlFor={`step-${index}`}
                                                className="form-label"
                                              >
                                                قدم
                                              </label>
                                              <input
                                                type="number"
                                                className="form-control"
                                                value={
                                                  saleTerms.groupSaleTerms
                                                    .rangeList[index].step
                                                }
                                                name
                                                id={`step-${index}`}
                                                onChange={e => {
                                                  flagHandler("group");
                                                  if (isLastRange(index)) {
                                                    let temp = [
                                                      ...saleTerms
                                                        .groupSaleTerms
                                                        .rangeList
                                                    ];
                                                    temp[index].step =
                                                      e.target.value;
                                                    setSaleTerms(prev => {
                                                      return {
                                                        ...prev,
                                                        groupSaleTerms: {
                                                          ...prev.groupSaleTerms,
                                                          rangeList: [...temp]
                                                        }
                                                      };
                                                    });
                                                  }
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </>
                              )}
                            </div>
                            <div className="d-flex justify-content-end">
                              <button
                                // type="button"
                                className="btn btn-secondary mx-1"
                                // data-bs-dismiss="modal"
                              >
                                انصراف
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={async () => {
                                  if (saleTerms["productId"] == "") {
                                    toast.error("لطفا محصول را انتخاب کنید!");
                                  } else {
                                    // if(type ==1)
                                    // let checkStatus = await checkInventory();
                                    // console.log("check status ", checkStatus);

                                    if (submitValidation()) {
                                      if (
                                        (saleTerms.groupSaleTerms.status &&
                                          saleTerms.groupSaleTerms
                                            .finishingDate != "" &&
                                          saleTerms.groupSaleTerms
                                            .deliveryPrice != "" &&
                                          saleTerms.groupSaleTerms.rangeList
                                            .length >= 2) ||
                                        !saleTerms.groupSaleTerms.status
                                      ) {
                                        // let status1 = await sendSingleTerms();
                                        setTextError(prev => {
                                          return { ...prev, submitError: "" };
                                        });
                                        if (
                                          type == "1" &&
                                          (await checkInventory())
                                        ) {
                                          singleFlag == false &&
                                          groupFlag == false
                                            ? toast.error(
                                                "تغییری برای ثبت ایجاد نشده است."
                                              )
                                            : await sendSingleTerms();
                                        } else if (type == "0") {
                                          groupFlag
                                            ? await sendGroupTerms()
                                            : toast.error(
                                                "تغییری برای ثبت ایجاد نشده است."
                                              );
                                        }

                                        // if (status1.status == 1) {
                                        //   toast.success(
                                        //     "شرایط تکی محصول با موفقیت اضافه شد."
                                        //   );
                                        // } else if (
                                        //   parseInt(status1.data.status) == -2
                                        // ) {
                                        //   toast.error(
                                        //     "شرایط فروش تکی برای این محصول از قبل تعریف شده است"
                                        //   );
                                        // }
                                        // let status2 = await sendGroupTerms();
                                        // if (status2.data.status == 1) {
                                        //   toast.success(
                                        //     "شرایط گروهی محصول با موفقیت اضافه شد."
                                        //   );
                                        //   setRangeCount(0);
                                        //   document
                                        //     .querySelector(
                                        //       "#addTermsOfSale .btn-close"
                                        //     )
                                        //     .click();
                                        //   setSaleTerms({
                                        //     productId: "",
                                        //     singleSaleTerms: {
                                        //       deliveryPrice: "",
                                        //       discountDate: "",
                                        //       maxCount: "",
                                        //       step: "",
                                        //       price: "",
                                        //       discount: "",
                                        //       itemcount: "",
                                        //     },
                                        //     groupSaleTerms: {
                                        //       finishingDate: "",
                                        //       deliveryPrice: "",
                                        //       status: false,
                                        //       rangeList: [
                                        //         {
                                        //           min: 0,
                                        //           max: 1,
                                        //           price: "",
                                        //           //  minCount: "",
                                        //           maxCount: "",
                                        //           step: "",
                                        //         },
                                        //       ],
                                        //     },
                                        //   });
                                        // } else {
                                        //   if (
                                        //     parseInt(status1.data.status) == -2
                                        //   ) {
                                        //     toast.error(
                                        //       "شرایط فروش تکی برای این محصول از قبل تعریف شده است"
                                        //     );
                                        //   } else {
                                        //     toast.error(" مشکلی پیش آمده است ");
                                        //   }
                                        // }
                                      } else {
                                        saleTerms.groupSaleTerms.status &&
                                          setTextError(prev => {
                                            return {
                                              ...prev,
                                              submitError: (
                                                <ol>
                                                  <li>
                                                    زمان اتمان فروش گروهی باید
                                                    مشخص کنید.{" "}
                                                  </li>
                                                  <li>
                                                    هزینه ارسال را مشخص کنید.
                                                  </li>

                                                  <li>
                                                    حداقل 2 رنج تعریف کنید.
                                                  </li>
                                                </ol>
                                              )
                                            };
                                          });
                                        // toast.error(
                                        //   "زمان اتمام فروش گروهی و هزینه ارسال را مشخص کنید"
                                        // );
                                      }
                                    }
                                  }
                                }}
                              >
                                ثبت
                              </button>
                            </div>
                          </form>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="recordSale"
                          role="tabpanel"
                          aria-labelledby="recordSale-tab"
                        >
                          {saleTerms.productId != "" ? (
                            <div className="d-flex flex-row flex-wrap shadow rounded info-item mt-5">
                              <div className="flex-grow-1 ">
                                <h6 className="pt-2 fs-12 text-center">
                                  تعداد کل
                                </h6>
                                <h6 className=" fs-12 text-center pt-1">
                                  21
                                  {/* {selectedProduct.mainshop_commission} */}
                                </h6>
                              </div>
                              <div className="flex-grow-1 ">
                                <h6 className="pt-2 fs-12 text-center">
                                  موجودی فعال
                                </h6>
                                <h6 className="  fs-12 text-center pt-1">
                                  {/* {selectedProduct.mainshop_commission} */}
                                  15
                                </h6>
                              </div>
                              <div className="flex-grow-1 ">
                                <h6 className="pt-2 fs-12 text-center">
                                  تعداد فروخته شده{" "}
                                </h6>
                                <h6 className=" fs-12 text-center pt-1">
                                  {/* {selectedProduct.mainshop_commission} */}6
                                </h6>
                              </div>
                              <div className="flex-grow-1 ">
                                <h6 className="pt-2 fs-12 text-center">
                                  درصد کمیسیون{" "}
                                </h6>
                                <h6 className=" fs-12 text-center pt-1">
                                  {/* {selectedProduct.mainshop_commission} */}7
                                </h6>
                              </div>
                              {/* <div className="flex-grow-1 ">
                                <h6 className="pt-2 fs-12 text-center">
                                  فروشگاهی که خرید انجام شده
                                </h6>
                                <h6 className=" fs-12 text-center pt-1">
                                  {/* {selectedProduct.mainshop_commission} */}

                              {/* </h6> */}
                              {/* </div> } */}
                            </div>
                          ) : (
                            <p className="mt-5">ابتدا محصول را انتخاب کنید.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal.Body>

                <div className="modal-footer"></div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
